// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"9b84b42d","101":"79a4db8e","404":"7b3008f1","483":"3139afc8","584":"c6b3e57b","943":"e75a666e","978":"1541dcb4"}[chunkId] + ".chunk.js";
};